import { TextMessageTemplateKey } from "./text-message-template-key";

export class TextMessageTemplate {
  static $type = 'TextMessageTemplate';

  textMessageTemplateId: string;
  code: TextMessageTemplateKey;
  template: string;

  constructor(data: Partial<TextMessageTemplate> = {}) {
    this.textMessageTemplateId = data.textMessageTemplateId ?? '';
    this.code = data.code!;
    this.template = data.template ?? '';
  }
}
